// extracted by mini-css-extract-plugin
export default {"root_stretchedX":"msV_fEzhvf","root_stretchedY":"H7E_NcvkCB"};